// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import favicon from './assets/Fivecon.png'; // Importe o favicon

// Adiciona o favicon ao head do documento
const link = document.createElement('link');
link.rel = 'icon';
link.href = favicon;
document.head.appendChild(link);

ReactDOM.render(<App />, document.getElementById('root'));
